import request from "@/services/request";
import store from "@/store";
import Table from "@/utils/Table";

async function getAllGroupedKcpIndicators() {
  try {
    const res = await request({
      endpoint: `/api/indicators/org?orgId=${store.getters['keycloak/userId']}`,
      method: 'get',
    });
    if (res.status === 200) {
      let returnData = [];
      const orgOwner = store.getters['spr/getMainOrg'];
      const orgFilials = store.getters['spr/getOrgsAll']?.filter(el => el.ownerId === orgOwner.id && el.id !== orgOwner.id);
      const usls = store.getters['spr/getUsls'].sort((a, b) => a?.id - b?.id);
      const mainOrgData = res.data.filter(el => el.orgId === orgOwner.id);
      const filialsData = orgFilials.map(el => {
        return res.data.filter(el2 => el2.orgId === el.id)
      });
      console.log(filialsData)
      returnData.push({
        orgName: orgOwner.name,
        orgId: orgOwner.id,
        ownerId: orgOwner.id,
        id: Math.random(),
        orgFlag: true
      })
      usls.forEach(el => {
        if (res.data.find(elData => elData.kcpGroup.usl.id === el.id)) {
          returnData.push(
            {
              id: Math.random(),
              uslName: el.name
            },
            ...mainOrgData.filter(elData => elData.kcpGroup.usl.id === el.id).map(elData => {
              return {
                ...elData,
                iokio22: elData.iokio22 === 'NA' ? null : Table.checkValueWithNullAndReturnND(elData.iokio22, 3, 'float'),
                iokiv22: elData.iokiv22 === 'NA' ? null : Table.checkValueWithNullAndReturnND(elData.iokiv22, 3, 'float'),
                iokiz22: elData.iokiz22 === 'NA' ? null : Table.checkValueWithNullAndReturnND(elData.iokiz22, 3, 'float'),
                iowgt22: elData.iowgt22 === 'NA' ? null : Table.checkValueWithNullAndReturnND(elData.iowgt22, 3, 'float')
              }
            })
          );
        }
      });
      if (filialsData.length > 0) {
        for (const elFilialData of filialsData) {
          if (elFilialData.length === 0) {
            continue
          }

          returnData.push(
            {
              orgName: elFilialData[0].orgName,
              orgId: elFilialData[0].orgId,
              ownerId: elFilialData[0].ownerId,
              id: Math.random(),
              orgFlag: true,
            }
          );
          usls.forEach(el => {
            if (elFilialData.find(elData => elData.kcpGroup.usl.id === el.id))
              returnData.push({
                id: Math.random(),
                uslName: el.name
              }, ...elFilialData.filter(elData => elData.kcpGroup.usl.id === el.id).map(elData => {
                return {
                  ...elData,
                  iokio22: elData.iokio22 === 'NA' ? null : Table.checkValueWithNullAndReturnND(elData.iokio22, 3, 'float'),
                  iokiv22: elData.iokiv22 === 'NA' ? null : Table.checkValueWithNullAndReturnND(elData.iokiv22, 3, 'float'),
                  iokiz22: elData.iokiz22 === 'NA' ? null : Table.checkValueWithNullAndReturnND(elData.iokiz22, 3, 'float'),
                  iowgt22: elData.iowgt22 === 'NA' ? null : Table.checkValueWithNullAndReturnND(elData.iowgt22, 3, 'float')
                }
              }));
          });
        }
      }
      return returnData;
    } else {
      throw new Error('error getAllGroupedKcpIndicators');
    }
  } catch (e) {
    await store.dispatch('notifications/addNotification', {
      notificationStatus: 'error',
      notificationMessage: 'ошибка получения общих показателей ' + ' ' + e,
      timeout: 3000
    }, {root: true});
    throw new Error('error getAllGroupedKcpIndicators ' + e)
  }
}

async function getAllGroupedKcpIndicatorsStage1(stage) {
  let url = `/api/indicators/kcp_result?orgId=${store.getters['keycloak/userId']}`
  if (stage === 8) {
    url = `/api/indicators/kcp_final?orgId=${store.getters['keycloak/userId']}`
  }
  try {
    const res = await request({
      endpoint: url,
      method: 'get',
    });
    if (res.status === 200) {
      let returnData = [];
      const orgOwner = store.getters['spr/getMainOrg'];
      const orgFilials = store.getters['spr/getOrgsAll']?.filter(el => el.ownerId === orgOwner.id && el.id !== orgOwner.id);
      const usls = store.getters['spr/getUsls'].sort((a, b) => a?.id - b?.id);
      const mainOrgData = res.data.filter(el => (el.orgId === orgOwner.id && (
          (el.qkcpo24 !== null || el.qkcpv24 !== null || el.qkcpz24 !== null) &&
          (el.qkcpo24 !== 'NA' || el.qkcpv24 !== 'NA' || el.qkcpz24 !== 'NA'))
      ));

      const filialsData = orgFilials.map(el => {
        return res.data.filter(el2 => (el2.orgId === el.id && (
          (el2.qkcpo24 !== null || el2.qkcpv24 !== null || el2.qkcpz24 !== null) &&
          (el2.qkcpo24 !== 'NA' || el2.qkcpv24 !== 'NA' || el2.qkcpz24 !== 'NA')
        )))
      });
      returnData.push(
        {
          orgName: orgOwner.name,
          orgId: orgOwner.id,
          ownerId: orgOwner.id,
          id: Math.random(),
          orgFlag: true
        }
      )
      usls.forEach(el => {
        if (res.data.find(elData => elData.kcpGroup.usl.id === el.id))
          returnData.push({
              id: Math.random(),
              uslName: el.name
            }, ...mainOrgData.filter(elData => elData.kcpGroup.usl.id === el.id).map(elData => {
              return {
                ...elData,
                qkcpo24: elData.qkcpo24 === 'NA' ? null : elData.qkcpo24,
                qkcpv24: elData.qkcpv24 === 'NA' ? null : elData.qkcpv24,
                qkcpz24: elData.qkcpz24 === 'NA' ? null : elData.qkcpz24,
              }
            })
          );
      });
      if (filialsData.length > 0) {
        for (const elFilialData of filialsData) {
          if (elFilialData.length === 0)
            continue;

          returnData.push(
            {
              orgName: elFilialData[0].orgName,
              orgId: elFilialData[0].orgId,
              ownerId: elFilialData[0].ownerId,
              id: Math.random(),
              orgFlag: true,
            }
          );
          usls.forEach(el => {
            if (elFilialData.find(elData => elData.kcpGroup.usl.id === el.id))
              returnData.push({
                id: Math.random(),
                uslName: el.name
              }, ...elFilialData.filter(elData => elData.kcpGroup.usl.id === el.id).map(elData => {
                return {
                  ...elData,
                  qkcpo24: elData.qkcpo24 === 'NA' ? null : elData.qkcpo24,
                  qkcpv24: elData.qkcpv24 === 'NA' ? null : elData.qkcpv24,
                  qkcpz24: elData.qkcpz24 === 'NA' ? null : elData.qkcpz24,
                }
              }));
          });
        }
      }
      return returnData;
    } else {
      throw new Error('error getAllGroupedKcpIndicatorsStage1');
    }
  } catch (e) {
    await store.dispatch('notifications/addNotification', {
      notificationStatus: 'error',
      notificationMessage: 'ошибка получения общих показателей ' + ' ' + e,
      timeout: 3000
    }, {root: true});
    throw new Error('error getAllGroupedKcpIndicatorsStage1 ' + e)
  }
}

async function getKcpIndicatorsSpr() {
  try {
    const res = await request({
      endpoint: `/api/indicators/list`,
      method: 'get',
    });
    if (res.status === 200) {
      return res;
    } else {
      throw new Error('error kcp spr pok');
    }
  } catch (e) {
    await store.dispatch('notifications/addNotification', {
      notificationStatus: 'error',
      notificationMessage: 'ошибка получения данных формы ' + ' ' + e,
      timeout: 3000
    }, {root: true});
    throw new Error(e)
  }
}

async function getAppeals() {
  try {
    const res = await request({
      endpoint: `/api/appeal/left?orgId=${store.getters['keycloak/userId']}`,
      method: 'get',
    });
    if (res.status === 200) {
      return res.data;
    } else {
      throw new Error('error getAppeals asdadasdhnaolshjakiadghjasdka');
    }
  } catch (e) {
    await store.dispatch('notifications/addNotification', {
      notificationStatus: 'error',
      notificationMessage: 'ошибка получения списка апелляций ' + ' ' + e,
      timeout: 3000
    }, {root: true});
    throw new Error('error getAppeals xcvvbn,m.nb,.vc' + e)
  }
}

async function sendAppealAdmin(payload) {
  try {
    const res = await request({
      endpoint: `/api/appeal/left/admin`,
      method: 'put',
      body: payload
    });
    if (res.status === 200 || res.status === 201) {
      return res.data;
    } else {
      throw new Error('error appeal post');
    }
  } catch (e) {
    await store.dispatch('notifications/addNotification', {
      notificationStatus: 'error',
      notificationMessage: 'ошибка отправки апелляции ' + ' ' + e,
      timeout: 3000
    }, {root: true});
    throw new Error('error appeal post' + e)
  }
}

async function declineIndicatorAppeal(payload) {
  try {
    const {id, foId, flag} = payload;
    const res = await request({
      endpoint: `/api/indicators/kcp_result_reject?rowId=${id}&foId=${foId}&flag=${flag}`,
      method: 'post',
    });
    if (res.status === 200 || res.status === 201) {
      return {
        ...res.data,
        qkcpo24: res.data.qkcpo24 === 'NA' ? null : res.data.qkcpo24,
        qkcpv24: res.data.qkcpv24 === 'NA' ? null : res.data.qkcpv24,
        qkcpz24: res.data.qkcpz24 === 'NA' ? null : res.data.qkcpz24,
      };
    } else {
      throw new Error('error appeal post');
    }
  } catch (e) {
    await store.dispatch('notifications/addNotification', {
      notificationStatus: 'error',
      notificationMessage: 'ошибка отказа от КЦП ' + ' ' + e,
      timeout: 3000
    }, {root: true});
    throw new Error('error appeal post' + e)
  }
}

async function getAppealsAdmin() {
  try {
    const res = await request({
      endpoint: `/api/appeal/left/admin`,
      method: 'get',
    });
    if (res.status === 200) {
      return res.data;
    } else {
      throw new Error('error getAppeals');
    }
  } catch (e) {
    await store.dispatch('notifications/addNotification', {
      notificationStatus: 'error',
      notificationMessage: 'ошибка получения списка апелляций ' + ' ' + e,
      timeout: 3000
    }, {root: true});
    throw new Error('error getAppeals' + e)
  }
}

//
// async function getAppealChangeCorrectValues() {
//   try {
//     const res = await request({
//       endpoint: `/api/kcpAdd/org?orgOwnerId=${store.getters['auth/get_replace_id_admin']}`,
//       method: 'get',
//     });
//     if (res.status === 200) {
//       return res.data;
//     } else {
//       throw new Error('error getAppealChangeCorrectValues');
//     }
//   } catch (e) {
//     await store.dispatch('notifications/addNotification', {
//       notificationStatus: 'error',
//       notificationMessage: 'ошибка получения ! ' + ' ' + e,
//       timeout: 3000
//     }, {root: true});
//     throw new Error('error getAppealChangeCorrectValues' + e)
//   }
// }
//
async function putAppeal(obj) {
  try {
    const res = await request({
      endpoint: `/api/appeal/left`,
      method: 'put',
      body: obj
    });
    if (res.status === 200) {
      return res.data;
    } else {
      throw new Error('error putAppeal');
    }
  } catch (e) {
    await store.dispatch('notifications/addNotification', {
      notificationStatus: 'error',
      notificationMessage: 'ошибка отправки апелляции ' + ' ' + e,
      timeout: 3000
    }, {root: true});
    throw new Error('error putAppeal' + e)
  }
}


async function getKcpIndicatorsFull(orgId = '', kcpGroup = '', usl = '', fo = '') {
  try {
    const params = `?orgId=${orgId}&kcpGroup=${kcpGroup}&usl=${usl}&fo=${fo}`;
    const res = await request({
      endpoint: `/api/indicators/all${params}`,
      method: 'get',
    });
    if (res.status === 200) {
      return res.data;
    } else {
      throw new Error('getKcpIndicatorsFull');
    }
  } catch (e) {
    await store.dispatch('notifications/addNotification', {
      notificationStatus: 'error',
      notificationMessage: 'ошибка получения данных формы ' + ' ' + e,
      timeout: 3000
    }, {root: true});
    throw new Error('getKcpIndicatorsFull ' + e)
  }
}


// ---------------------- allListStage1CorrectValues -----------------------------


async function getAllGroupedKcpIndicatorsStage1CorrectValues() {
  try {
    const res = await request({
      endpoint: `/api/kcpAdd?orgOwnerId=${store.getters['keycloak/userId']}`,
      method: 'get',
    });
    if (res.status === 200) {
      let returnData = [];
      const orgOwner = store.getters['spr/getMainOrg'];
      const orgFilials = store.getters['spr/getOrgsAll']?.filter(el => el.ownerId === orgOwner.id && el.id !== orgOwner.id);
      const usls = store.getters['spr/getUsls'].sort((a, b) => a?.id - b?.id);
      const mainOrgData = res.data.filter(el => (el.org?.id === orgOwner.id && (
        el.qkcpo24Add !== 'NA' || el.qkcpv24Add !== 'NA' || el.qkcpz24Add !== 'NA')));
      const filialsData = orgFilials.map(el => {
        return res.data.filter(el2 => (el2.org?.id === el.id && (
          el2.qkcpo24Add !== 'NA' || el2.qkcpv24Add !== 'NA' || el2.qkcpz24Add !== 'NA'
        )))
      });

      returnData.push({
        orgName: orgOwner.name,
        orgId: orgOwner.id,
        ownerId: orgOwner.id,
        id: Math.random(),
        orgFlag: true
      })

      usls.forEach(el => {
        if (res.data.find(elData => elData.kcpGroup.usl.id === el.id)) {
          returnData.push({
            id: Math.random(),
            uslName: el.name,
          }, ...mainOrgData.filter(elData => elData.kcpGroup?.usl.id === el.id).map(elData => {
            return {
              ...elData,
              qkcpo24Add: elData.qkcpo24Add === 'NA' ? null : elData.qkcpo24Add,
              qkcpv24Add: elData.qkcpv24Add === 'NA' ? null : elData.qkcpv24Add,
              qkcpz24Add: elData.qkcpz24Add === 'NA' ? null : elData.qkcpz24Add,
              qkcpo24Accept: elData.qkcpo24Accept === 'NA' ? null : Number(elData.qkcpo24Accept),
              qkcpv24Accept: elData.qkcpv24Accept === 'NA' ? null : Number(elData.qkcpv24Accept),
              qkcpz24Accept: elData.qkcpz24Accept === 'NA' ? null : Number(elData.qkcpz24Accept),
            }
          }));
        }
      });

      if (filialsData.length > 0) {
        for (const elFilialData of filialsData) {
          if (elFilialData.length === 0)
            continue;

          returnData.push({
            orgName: elFilialData[0].org?.name,
            orgId: elFilialData[0].org?.id,
            ownerId: elFilialData[0].org?.owner?.id,
            id: Math.random(),
            orgFlag: true,
          });
          usls.forEach(el => {
            if (elFilialData.find(elData => elData.kcpGroup?.usl.id === el.id))
              returnData.push({
                id: Math.random(),
                uslName: el.name
              }, ...elFilialData.filter(elData => elData.kcpGroup?.usl.id === el.id).map(elData => {
                return {
                  ...elData,
                  qkcpo24Add: elData.qkcpo24Add === 'NA' ? null : elData.qkcpo24Add,
                  qkcpv24Add: elData.qkcpv24Add === 'NA' ? null : elData.qkcpv24Add,
                  qkcpz24Add: elData.qkcpz24Add === 'NA' ? null : elData.qkcpz24Add,
                  qkcpo24Accept: elData.qkcpo24Accept === 'NA' ? null : Number(elData.qkcpo24Accept),
                  qkcpv24Accept: elData.qkcpv24Accept === 'NA' ? null : Number(elData.qkcpv24Accept),
                  qkcpz24Accept: elData.qkcpz24Accept === 'NA' ? null : Number(elData.qkcpz24Accept),
                }
              }));
          });
        }
      }
      return returnData;
    } else {
      throw new Error('error getAllGroupedKcpIndicatorsStage1');
    }
  } catch (e) {
    await store.dispatch('notifications/addNotification', {
      notificationStatus: 'error',
      notificationMessage: 'ошибка получения общих показателей ' + ' ' + e,
      timeout: 3000
    }, {root: true});
    throw new Error('error getAllGroupedKcpIndicatorsStage1 ' + e)
  }
}

async function getBlockCorrectIndicatorInfo() {
  try {
    const res = await request({
      endpoint: `/api/kcpAdd/block?orgId=${store.getters['keycloak/userId']}`,
      method: 'get',
    });
    if (res.status === 200) {
      return res.data;
    } else {
      throw new Error('getBlockCorrectIndicatorInfo');
    }
  } catch (e) {
    await store.dispatch('notifications/addNotification', {
      notificationStatus: 'error',
      notificationMessage: 'ошибка получения блокировки' + ' ' + e,
      timeout: 3000
    }, {root: true});
    throw new Error('getBlockCorrectIndicatorInfo ' + e)
  }
}

async function setBlockCorrectIndicatorInfo(obj) {
  try {
    const res = await request({
      endpoint: `/api/kcpAdd/block?orgId=${store.getters['keycloak/userId']}`,
      method: 'put',
      body: obj
    });
    if (res.status === 200) {
      return res.data;
    } else {
      throw new Error('getBlockCorrectIndicatorInfo');
    }
  } catch (e) {
    await store.dispatch('notifications/addNotification', {
      notificationStatus: 'error',
      notificationMessage: 'ошибка получения блокировки' + ' ' + e,
      timeout: 3000
    }, {root: true});
    throw new Error('getBlockCorrectIndicatorInfo ' + e)
  }
}

async function putCorrectValueAppeal(obj) {
  try {
    const res = await request({
      endpoint: `/api/kcpAdd`,
      method: 'put',
      body: obj
    });
    if (res.status === 200) {
      return res.data;
    } else {
      throw new Error('error putCorrectValueAppeal');
    }
  } catch (e) {
    await store.dispatch('notifications/addNotification', {
      notificationStatus: 'error',
      notificationMessage: 'ошибка отправки ' + ' ' + e,
      timeout: 3000
    }, {root: true});
    throw new Error('error putCorrectValueAppeal' + e)
  }
}

async function hasAddKcpCheck() {
  try {
    const res = await request({
      endpoint: `/api/kcpAdd/has_add_kcp?orgOwnerId=${store.getters['keycloak/userId']}`,
      method: 'get',
    });
    if (res.status === 200) {
      return res.data;
    } else {
      throw new Error('hasAddKcpCheck');
    }
  } catch (e) {
    await store.dispatch('notifications/addNotification', {
      notificationStatus: 'error',
      notificationMessage: 'ошибка получения блокировки' + ' ' + e,
      timeout: 3000
    }, {root: true});
    throw new Error('hasAddKcpCheck ' + e)
  }
}

export {
  getAllGroupedKcpIndicators,
  getKcpIndicatorsFull,
  getAppeals,
  putAppeal,
  getKcpIndicatorsSpr,
  getAllGroupedKcpIndicatorsStage1,
  getBlockCorrectIndicatorInfo,
  setBlockCorrectIndicatorInfo,
  // getAppealChangeCorrectValues,
  putCorrectValueAppeal,
  getAppealsAdmin,
  sendAppealAdmin,
  declineIndicatorAppeal,
  getAllGroupedKcpIndicatorsStage1CorrectValues,
  hasAddKcpCheck
}